/*
 * 機能別コンポーネント 一覧パネル画面で使用するconst・interface・types
 *   更新履歴
 */

import { ColumnListAll, ColumnListOA, ColumnListFJapan } from '@/constants/matter/matterList';
import { searchFormMatterALL, searchFormMatterOA, searchFormMatterFJapan } from '@/constants/form/search';

// 一覧内のチップ背景色情報 (色、カラム名)
export const chipItems = [{ color: '', name: 'status', class: 'status-tag--order' }];
// 一覧内でボタンを表示するColumn
export const buttonItems = [
  {
    'alwaysDisplayed': true,
    'class': 'btn-normal',
    'name': "detail",
    'text': "詳細",
    'disabled': false
  }
];

/**
 * 切り替え用の定義
 * 判別用の値('S001')
 * dataReportSelected：参照するデータレポート
 * searchForm 検索条件項目。search.tsに設定
 * selectDispCol 検索結果カラム。conpornents下で画面ごとに設定
 */
export const selectSearchInfo: { [k: string]: any } = {
  '1': [
    {
      searchForm: searchFormMatterOA,
      selectDispCol: ColumnListOA
    }
  ],
  '99': [
    {
      searchForm: searchFormMatterALL,
      selectDispCol: ColumnListAll
    }
  ],
  '2': [
    {
      searchForm: searchFormMatterFJapan,
      selectDispCol: ColumnListFJapan
    }
  ],
  'Default': [
    {
      searchForm: searchFormMatterFJapan,
      selectDispCol: ColumnListFJapan
    }
  ]
};

//顧客ID連動セレクトボックス
export const narrowDownSelectOption: Array<any> = [
  {
    keyDisplayId: 'customer_id',
    targetDisplayId: 'department_billing_address_id',
    keyDisplayName: 'i_id'
  },
  {
    keyDisplayId: 'customer_id',
    targetDisplayId: 'department_delivery_destination_id',
    keyDisplayName: 'i_id'
  }
];

// 検索で使用するステータス項目
export const selectSampleStatusId = ['ステータス１', 'ステータス２'];

// 検索で使用しないステータス項目(API仕様時にNOT条件とする)
export const notSearchSampleStatusId = [
  'order_purchase_preparing',
  'order_purchase_estimate_request_applied',
  'order_purchase_estimate_request_approved',
  'order_estimate_requesting',
  'order_estimate_registered',
  'order_purchase_order_request_applied',
  'order_purchase_order_request_approved',
  'order_purchase_deleted',
  'order_deleted'
];
